import $api from "../api/config";
import type { AxiosResponse } from "axios";
import { TaskType } from "../types/task-type";

export interface ClientApplicationData {
  name: string;
  email: string;
  telegram_username: string;
  phone: string;
  type: TaskType;
  description: string;
  telegram_user_id?: string;
  files?: File[];
}

export interface ClientApplicationResponse {
  id: number;
  name: string;
  telegram_user_id: string;
  email: string;
  description: string;
  type: string;
  telegram_username: string;
  files: Array<{
    id: number;
    file: string;
  }>;
}

export const submitClientApplication = async (
  data: ClientApplicationData
): Promise<AxiosResponse<ClientApplicationResponse>> => {
  const formData = new FormData();

  formData.append("name", data.name);
  formData.append("phone", data.phone);
  formData.append("email", data.email);
  formData.append("telegram_username", data.telegram_username);
  formData.append("type", data.type);
  formData.append("description", data.description);

  if (data.telegram_user_id) {
    formData.append("telegram_user_id", data.telegram_user_id);
  }

  if (data.files && data.files.length > 0) {
    data.files.forEach((file, index) => {
      formData.append(`files[${index}]`, file);
    });
  }

  return $api.post("/client-applications/", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};
